module.exports = __webpack_public_path__ + "static/img/bg_sh.59c1abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_sh.png
// module id = TUJt
// module chunks = 0